import React from "react";
import { NavLink } from "@/components/nav-link";
import { Facebook, Linkedin, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer: React.FC = () => {
  return (
    <footer className="relative bg-[#0f1115] text-white overflow-hidden min-h-[70vh] flex flex-col justify-between">
      {/* Ambient Background Glows */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-indigo-900/20 rounded-full blur-[128px] pointer-events-none opacity-50" />
      <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-purple-900/10 rounded-full blur-[128px] pointer-events-none opacity-30" />

      <div className="container relative z-10 pt-24 pb-12 flex-1 flex flex-col">

        {/* Newsletter / Top Section */}
        <div className="w-full max-w-4xl mx-auto text-center mb-8">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6">
            Stay ahead in your <span className="text-indigo-400">preparation.</span>
          </h2>
          <p className="text-lg text-gray-400 mb-10 max-w-xl mx-auto">
  Stay informed with the latest UPSC trends, expert answer writing tips, and platform updates designed to accelerate your success.
</p>

          
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-10 lg:gap-8 border-t border-white/5 pt-16">
          {/* Brand Column - Wider */}
          <div className="col-span-2 md:col-span-2 lg:col-span-2 space-y-6">
              <NavLink to="/" className="flex flex-col items-start leading-none group">
            <h1 className="text-4xl flex gap-1 font-black tracking-tighter bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 bg-clip-text text-transparent pb-1">
             <img className="h-10 translate-y-1" src="/logoremovedbg.webp" alt="" /> parakh
            </h1>
            <span className="text-[8px] font-medium text-gray-500 translate-x-16 -translate-y-1 -mt-1 group-hover:text-gray-700 transition-colors">
              Powered by Kuberya AI
            </span>
          </NavLink>
            <p className="text-base text-gray-400 leading-relaxed max-w-sm">
              The advanced AI-powered platform for UPSC Mains answer evaluation. We help aspirants write better, faster, and more accurately.
            </p>
            <div className="flex gap-4 pt-2">
              <a href="#" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-white hover:text-indigo-600 transition-all duration-300">
                <Mail href="mailto:kuberyaai@gmail.com" className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61575507550246" target="_blank" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-white hover:text-blue-500 transition-all duration-300">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/kuberya-ai/" target="_blank" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-gray-400 hover:bg-white hover:text-blue-700 transition-all duration-300">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links Columns */}
          <div className="space-y-6">
            <h3 className="font-bold text-lg text-white">Platform</h3>
            <nav className="flex flex-col space-y-4">
              <NavLink to="/evaluate" className="text-gray-400 hover:text-white transition-colors">Evaluate</NavLink>
              <NavLink to="/history" className="text-gray-400 hover:text-white transition-colors">History</NavLink>
              {/* <NavLink to="/pricing" className="text-gray-400 hover:text-white transition-colors">Pricing</NavLink> */}
            
            </nav>
          </div>

          <div className="space-y-6">
            <h3 className="font-bold text-lg text-white">Company</h3>
            <nav className="flex flex-col space-y-4">
              <NavLink to="/about-us" className="text-gray-400 hover:text-white transition-colors">About Us</NavLink>
              
              <NavLink to="/about-us#contact" className="text-gray-400 hover:text-white transition-colors">Contact</NavLink>
            </nav>
          </div>

          <div className="space-y-6">
            <h3 className="font-bold text-lg text-white">Legal</h3>
            <nav className="flex flex-col space-y-4">
              <NavLink to="/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy</NavLink>
              <NavLink to="/terms" className="text-gray-400 hover:text-white transition-colors">Terms</NavLink>
              <NavLink to="/security" className="text-gray-400 hover:text-white transition-colors">Security</NavLink>
              
            </nav>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/5 bg-black/20">
        <div className="container py-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
          <p>© {new Date().getFullYear()} Kuberya-AI Solutions. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <span>Powered by <Link to="https://www.kuberya.com/" target="_blank" className=" hover:text-gray-300 transition-colors text-purple-300">Kuberya AI</Link></span>
          </div>
        </div>
      </div>
    </footer>
  );
};
